"use client";

import { useState } from "react";
import { usePathname } from "next/navigation";
import { useFetchDetailLayananData } from "@/hooks/fetchDetailLayananData";
import Core from "@/components/core";

const LayananPage = () => {
  const pathname = usePathname();
  const slug = pathname.split("/").filter(Boolean).pop() ?? "";
  const detailLayanan = useFetchDetailLayananData(slug);

  const itemsPerPage = 4;
  const [page, setPage] = useState(0);

  const startIndex = page * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = detailLayanan.slice(startIndex, endIndex);

  const goToNextPage = () => {
    setPage((prevPage) =>
      Math.min(prevPage + 1, Math.ceil(detailLayanan.length / itemsPerPage) - 1)
    );
  };

  const goToPreviousPage = () => {
    setPage((prevPage) => Math.max(prevPage - 1, 0));
  };

  const convertDescriptionToHTML = (description: string) => {
    return { __html: description };
  };

  return (
    <>
      <div className="grid lg:grid-cols-2 grid-cols-1 gap-[30px]">
        {currentItems.map((item: any, index: any) => (
          <Core.Card
            caseType="blog"
            key={index}
            image={`https://admin.macspace.id/public/${item.image}`}
            title={item.name}
            link={item.slug}
            content={
              <div
                dangerouslySetInnerHTML={convertDescriptionToHTML(item.content)}
              />
            }
          />
        ))}
      </div>
      <div className="grid md:grid-cols-12 grid-cols-1 mt-8">
        <Core.Pagination
          currentPage={page}
          totalItems={detailLayanan.length}
          itemsPerPage={itemsPerPage}
          onNextPage={goToNextPage}
          onPreviousPage={goToPreviousPage}
        />
      </div>
    </>
  );
};

export default LayananPage;
